import { ExternalSync, RelationshipType, SubmissionFailureReason } from '@common/entities';
import { get, patch } from 'config/api/config';

const RESPONSE_ENDPOINT = '/viewer/responses';
const UPDATE_DIGITAL_SIGNATURE = 'digital-signature';

interface PatchResponse {
  currentPageId: string;
  targetPageId?: string;
  responses: { [key: string]: any }[];
  errorCount?: number;
}

export interface UpdateResponseResult {
  responses: { [key: string]: any }[];
  externalSync?: ExternalSync;
}

interface PatchResponseForId {
  responseData: PatchResponse;
  responseId: string;
  /** When true, PATCH uses `?awaitSync=true` so the API waits for response.updated listeners. */
  awaitSync?: boolean;
}

export const patchResponseForId = async (data: PatchResponseForId) => {
  const query = data.awaitSync === true ? '?awaitSync=true' : '';
  return patch(`${RESPONSE_ENDPOINT}/${data.responseId}${query}`, data.responseData);
};

export const patchDigitalSignature = async (data: PatchResponseForId) => {
  const response = await patch(
    `${RESPONSE_ENDPOINT}/${data.responseId}/${UPDATE_DIGITAL_SIGNATURE}`,
    data.responseData,
  );
  return response;
};

interface GetResponseResult {
  applicationId: string;
  clientId: number;
  details: string;
  entrataApplicationId: number;
  entrataCustomerRelationshipId: number;
  formId: string;
  id: string;
  leaseId: number;
  paymentAccountId: number;
  paymentProcessed: boolean;
  primaryApplicationResponseId: string;
  relationshipType: RelationshipType;
  startDate: string;
  updatedDate: string;
  userId: number;
}
export const getResponse = async (responseId: string, viewerId?: string) => {
  if (!responseId) throw new Error('Response Id is missing.');

  const response = viewerId
    ? await get<GetResponseResult>(`${RESPONSE_ENDPOINT}/${responseId}`, {
        headers: { 'x-form-viewer-id': viewerId },
      })
    : await get<GetResponseResult>(`${RESPONSE_ENDPOINT}/${responseId}`);
  return response;
};

export interface SubmissionStatusResponse {
  submissionStatus: string | null;
  submissionStartedAt: string | null;
  submissionCompletedAt: string | null;
  failureReason?: SubmissionFailureReason | null;
}

export const getSubmissionStatus = async (
  responseId: string,
): Promise<SubmissionStatusResponse> => {
  if (!responseId) throw new Error('Response Id is missing.');

  const response = await get<SubmissionStatusResponse>(
    `/viewer/response/${responseId}/submission-status`,
  );
  return response.data;
};
